/* eslint-disable import/no-cycle */
/* eslint-disable no-return-assign */
import axiosIns from '@/libs/axios'
// import { requestApi } from '@/libs/secret'

export default {
  namespaced: true,
  state: {
    dataInbox: {
      statusMessage: [
        {
          0: 'StarIcon', 1: 'CreditCardIcon', 2: 'UserIcon', 3: 'CastIcon',
        },
        {
          0: 'badge-light-primary', 1: 'badge-light-success', 2: 'badge-light-warning', 3: ' badge-light-danger',
        },

      ],
      open: null,
      data: [],
    },
    totalUnread: 0,
  },
  getters: {
    getInboxList: state => state.dataInbox.data,
    getInboxStatus: state => state.dataInbox.statusMessage,
    getInboxOpen: state => state.dataInbox.open,
    getUnread: state => state.totalUnread,
  },
  mutations: {
    SET_DATA_INBOX: (state, value) => (value ? (state.dataInbox.data = value) : (state.dataInbox.data = [])),
    SET_DATA_OPEN: (state, value) => (value ? (state.dataInbox.open = value) : (state.dataInbox.open = null)),
    SET_UNREAD: (state, value) => state.totalUnread = value,
  },
  actions: {
    getInBox({ commit }) {
      const listMessages = {
        data: [
          {
            id: 432,
            autor: 'IOH Analyst Report',
            avatar: 'admin-small.png',
            title: 'Campaing is a running',
            time: '2021-09-28T18:20:30',
            type: 1,
            msg: '<h3>Campaing is a running</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
            status: 1,
          },
          {
            id: 100,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Your payment has been reciep',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 121,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Message 1',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 122,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Message 2',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 123,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Message 3',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries </br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</br></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 124,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Message 4',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 125,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Message 5',
            time: '2021-06-11T10:20:10Z',
            type: 0,
            msg: '<h3>Your payment has been reciep</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 101,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Setting your security',
            time: '2021-03-11T10:10:30Z',
            type: 3,
            msg: '<h3>Setting your security</h3></br><b>dear Lutfi</b></br>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
          {
            id: 102,
            autor: 'IOH Support',
            avatar: 'admin-small.png',
            title: 'Welcome',
            time: '2021-02-11T10:25:03Z',
            type: 2,
            msg: '<h3>Welcome</h3></br><b>dear Lutfi</b></br> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry"s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
          },
        ],
      }
      commit('SET_DATA_INBOX', listMessages.data)
    },
    listInbox({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/inbox', { headers })
          .then(response => {
            const newData = response.data.data
            // console.log(newData, 'inbox')
            commit('SET_DATA_INBOX', newData)
            let totalMessage = newData.filter(row => row.status === '0')
            // console.log(totalMessage.length)
            commit('SET_UNREAD', totalMessage.length)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    updateStatus({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.post('/inbox/read', payload, { headers })
          .then(response => {
            // const newData = response.data
            // commit('SET_DATA_REPORT_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    deleteMessages({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.post('/inbox/delete', payload, { headers })
          .then(response => {
            // const newData = response.data
            // commit('SET_DATA_REPORT_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
